module.exports = __webpack_public_path__ + "img/image13.6e7d23ab.jpg";